import { render, staticRenderFns } from "./CostsResearch.vue?vue&type=template&id=1eac65d5&"
import script from "./CostsResearch.vue?vue&type=script&lang=js&"
export * from "./CostsResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports